import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const AboutSection = () => {
  const navigate = useNavigate();

  return (
    <section className="py-20 px-6 bg-white" id="about">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-[#003366] mb-8 text-center">
          BC&apos;s Trusted Staffing Partner for Employers
        </h2>
        <div className="space-y-5 text-base text-gray-700 leading-relaxed">
          <p>
            <strong className="text-[#003366]">WorkNation Labour Ltd</strong> is a staffing agency headquartered in Vancouver, British Columbia, providing workforce solutions to businesses across the province. We specialize in supplying qualified, reliable workers in <strong>construction, warehouse & fulfillment, food processing, agriculture, transportation, and cold storage</strong>.
          </p>
          <p>
            With <strong>200+ workers placed</strong> across British Columbia, we understand the staffing challenges businesses face — seasonal demand spikes, urgent project needs, and the difficulty of finding dependable workers on short notice. That&apos;s why we built WorkNation: to give employers a single, reliable source for pre-screened, WCB-compliant labour.</p>
          <p>
            WorkNation Labour Ltd provides temporary, contract, and permanent staffing solutions. We handle payroll, WCB compliance, and all administrative requirements so you can focus on running your business. Our staffing solutions include:
          </p>
          <ul className="grid md:grid-cols-2 gap-3 my-6">
            {[
              'Temporary and seasonal workers',
              'On-call and project-based labour',
              'Warehouse and fulfillment staff',
              'Food processing production workers',
              'Skilled trades personnel',
              'Agriculture and farm labour',
              'Transportation and drivers',
              'Cold storage and freezer workers',
              'Forklift operators (certified)',
              'Cleaning and sanitation crews',
            ].map((item, i) => (
              <li key={i} className="flex items-start">
                <span className="text-[#003366] font-bold mr-3 text-xl leading-none mt-0.5" aria-hidden="true">&bull;</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
          <p>
            We handle the difficult, time-consuming work of finding the right position or right staff member for you. Place your trust in our agency to manage job placement, payroll requirements, WCB coverage, and more. WorkNation is based in Vancouver and serves employers and workers across Metro Vancouver, Surrey, Burnaby, Richmond, Delta, Langley, Abbotsford, the Fraser Valley, and all of British Columbia.
          </p>
          <p className="font-semibold text-[#003366] text-lg">
            Need workers for your next project?{' '}
            <span onClick={() => navigate('/employers')} className="cursor-pointer hover:underline" role="link" tabIndex={0}>
              Request staffing now
            </span>{' '}
            — or{' '}
            <span onClick={() => navigate('/job-seekers')} className="cursor-pointer hover:underline" role="link" tabIndex={0}>
              register for work
            </span>{' '}
            if you&apos;re looking for opportunities.
          </p>
        </div>

        <div className="mt-10 p-8 bg-gray-50 rounded-xl border-l-4 border-[#003366]">
          <h3 className="text-2xl font-bold text-[#003366] mb-4">Contact Information</h3>
          <div className="space-y-3 text-base text-gray-700">
            <p className="font-semibold">Vancouver, British Columbia</p>
            <p>
              <strong>For Employers:</strong>{' '}
              <a href="mailto:info@worknation.ca" className="text-[#003366] hover:underline">info@worknation.ca</a>
            </p>
            <p>
              <strong>For Job Seekers:</strong>{' '}
              <a href="mailto:resumeworknation@gmail.com" className="text-[#003366] hover:underline">resumeworknation@gmail.com</a>
            </p>
          </div>
          <button
            onClick={() => navigate('/about')}
            className="mt-4 inline-flex items-center text-[#003366] font-semibold hover:underline"
          >
            Learn more about WorkNation <ArrowRight className="ml-2" size={16} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
